import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { track } from '../../../utils/analytics';
import { emptyStateText } from '../../../utils/buyerInsightsFormat';

// `text` overrides the Products copy (Brands passes brandEmptyText).
const EmptyState = ({ view, n, q, hasFilters, group, sale, soldOutAt, signature, tab = 'products', text }) => {
  useEffect(() => {
    track('Buyer Insights Empty State Shown', { tab, view, with_filters: Boolean(hasFilters || q) });
  }, [signature]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Box sx={{ py: 6, textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        {text || emptyStateText(view, { n, q, hasFilters, group, sale, soldOutAt })}
      </Typography>
    </Box>
  );
};

export default EmptyState;
